import logo from "./logo.png";
import Dictionary from "./Dictionary";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          <img src={logo} className="App-logo img-fluid" alt="logo" />
        </header>
        <main>
          <Dictionary defaultKeyword="sunset" />
        </main>
        <footer className="App-footer">
          This progect was coded by{" "}
          <a
            href="https://www.linkedin.com/in/natalia-hishpan-91333622a/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Nataliia Hishpan
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/NataliHishpan/dictionary-project.git"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourse on GitHub
          </a>
        </footer>
      </div>
    </div>
  );
}
